import type { MutableRefObject } from "react";
import { useEffect, useRef } from "react";

const useLatestValue = <V>(value: V): Readonly<MutableRefObject<V>> => {
    const latestValueRef = useRef<V>(value);

    useEffect(() => {
        latestValueRef.current = value;
    }, [value]);

    return latestValueRef;
};

export default useLatestValue;
